import React from "react";
import { useMediaQuery } from "@mui/material";
import { Pill } from "@beamcloud/design-system";
import { device } from "constants/Devices";
import styled from "styled-components";

interface INotificationProps {}

const Notification: React.FC<INotificationProps> = () => {
  const isMobile = useMediaQuery(device.mobileXL);

  return (
    <Container isMobile={isMobile}>
      {!isMobile && (
        <StyledPill
          onClick={() => window.open("https://calendly.com/elimernit/beam-concierge-migration", "_blank")}
          type="body-purple"
          text="Volume Discounts Available"
        />
      )}
      <a href="https://calendly.com/elimernit/beam-concierge-migration">
        Book a call and estimate your savings
      </a>
    </Container>
  );
};

export default Notification;

const Container = styled.div<{ isMobile: boolean }>`
  background-color: ${props => props.theme.colors.gray850};
  width: ${props => (props.isMobile ? "90%" : "max-content")};
  margin: auto;
  border-radius: 8px;
  padding: ${props => props.theme.spacing.s2} ${props => props.theme.spacing.s3};
  ${props => props.theme.styleSet.textSm};
  color: ${props => props.theme.colors.gray300};
  border: 1px solid ${props => props.theme.colors.gray7};
  display: flex;
  align-items: center;
  column-gap: 12px;
  text-align: ${props => (props.isMobile ? "center" : "left")};

  a {
    color: inherit;
    text-decoration: none;
    ${props =>
      props.isMobile &&
      `
      width: 100%;
    `}
  }

  &:hover {
    opacity: 0.9;
  }

  @media ${device.mobileXL} {
    flex-direction: column;
    row-gap: 8px;
  }
`;

const StyledPill = styled(Pill)`
  cursor: pointer;
`;
